import { render } from "./ForgotPassword.vue?vue&type=template&id=64707b73"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
script.render = render

export default script